import React, { useEffect, useState } from "react";
import {
  Button,
  EmployeeHeader,
  NewTab,
  PageHeader,
  PageTab,
  PageTabAdv,
  showToast,
} from "../../../../components";
import WorkAuthorizationTab from "./WorkAuthorization/WorkAuthorizationTab";
import Passport from "./WorkAuthorization/Passport";
import I94 from "./WorkAuthorization/I94";
import EVerifiy from "./WorkAuthorization/EVerifiy";
import WorkAuthorizationModal from "./WorkAuthorization/WorkAuthorizationModals/WorkAuthorizationModal";
import PassportModal from "./WorkAuthorization/WorkAuthorizationModals/PassportModal";
import EVerifyModal from "./WorkAuthorization/WorkAuthorizationModals/EVerifyModal";
import I140Modal from "./WorkAuthorization/WorkAuthorizationModals/I140Modal";
import I94Modal from "./WorkAuthorization/WorkAuthorizationModals/I94Modal";
import { useSelector, useDispatch } from "react-redux";
import LCAInformation from "./Immigration/LcaTabs/LCAInformation";
import JobDetails from "./Immigration/LcaTabs/JobDetails";
import {
  addCurrentImmigrations,
  getCurrentEmployeeImmigration,
} from "../../../../redux/slices/immigration/immigrationSlice";
import { getEmployeeByUiidStart } from "../../../../redux/slices/employee/employeeSlice";
import LcaTab from "./Immigration/LcaTabs/LcaTab";
import Lca from "./Immigration/Lca";
import HoneBTab from "./Immigration/HoneBTab/HoneBTab";
import HoneB from "./Immigration/HoneB";
import Visa from "./Immigration/Visa";
import HoneBModal from "./Immigration/ImmigrationModal/HoneBModal";
import VisaModal from "./Immigration/ImmigrationModal/VisaModal";
import { useNavigate } from "react-router-dom";

const WorkAuthorization = () => {
  const dispatch = useDispatch();
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [manualMode, setManualMode] = useState(false);
  const [editData, setEditData] = useState(null);

  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    loading,
    error,
    employees,
    totalCount,
  } = useSelector((state) => state.employee);
  const { immigrations: immigrationsTableData } = useSelector(
    (state) => state.immigration,
  );
  const { currentEmployeeImmigration } = useSelector(
    (state) => state.immigration,
  );
  console.log("currentEmployeeImmigration", currentEmployeeImmigration);
  const lcaTableData = currentEmployeeImmigration?.lca || [];
  const tableDataLCA =
    Array.isArray(lcaTableData) && lcaTableData.length > 0 ? lcaTableData : [];

  const handleRemove = () => {
    console.log("-----");
    dispatch(addCurrentImmigrations({}));
  };

  const handleHoneBEdit = (rowData) => {
    setEditData(rowData);
    setActiveSubTab("honeB");
  };
  const handleEditVisa = (rowData) => {
    setEditData(rowData);
    handleOpenModal("visa");
    handleRemove();
  };
  const handleEditLca = (rowData) => {
    setManualMode(true);
    handleRemove();
    setEditData(rowData);
  };

  const handleBackOrCancel = () => {
    if (manualMode) {
      setManualMode(false);
      setActiveSubTab(null);
    } else {
      setActiveSubTab(null);
    }
    setEditData(null); // Clear edit data when going back
  };

  const handleAddH1B = () => {
    if (tableDataLCA.length > 0) {
      setEditData(null);
      setActiveSubTab("honeB");
      handleRemove();
    } else {
      showToast("Please complete the LCA section after adding the H1B.");
    }
  };
  //  i
  //Check Current Employee Have passport details or not
  const hasPassportData =
    employeeDetails?.passport &&
    Object.keys(employeeDetails.passport)
      .filter((key) => key !== "documents")
      .some((key) => employeeDetails.passport[key]);

  //Check Current Employee Have eVerify details or not
  const hasEVerifyData =
    employeeDetails?.eVerify &&
    Object.keys(employeeDetails.eVerify)
      .filter((key) => key !== "documents")
      .some((key) => employeeDetails.eVerify[key]);

  const [activeModal, setActiveModal] = useState(null);
  const [edit, setEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const handleOpenModal = (modalType) => {
    setEdit(false);
    setActiveModal(modalType);
    setSelectedRow(null);
  };

  const handleCloseModal = () => {
    setActiveModal(null);
  };
  const handleEditWorkAuth = (row) => {
    setSelectedRow(row);
    setEdit(true);
    setActiveModal("workAuthorization");
  };
  const handleEditPassPort = (row) => {
    setSelectedRow(row);
    setEdit(true);
    setActiveModal("passport");
  };
  const handleEdit194 = (row) => {
    setSelectedRow(row);
    setEdit(true);
    setActiveModal("94");
  };
  const handleEditEVerifiy = (row) => {
    setSelectedRow(row);
    setEdit(true);
    setActiveModal("eVerifiy");
  };
  const ModalComponents = {
    workAuthorization: WorkAuthorizationModal,
    passport: PassportModal,
    94: I94Modal,
    140: I140Modal,
    eVerifiy: EVerifyModal,
    honeB: HoneBModal,
    visa: VisaModal,
  };

  const renderActiveModal = () => {
    if (!activeModal) return null;
    const ModalComponent = ModalComponents[activeModal];
    return (
      // <ModalComponent
      //   isOpen={true}
      //   onClose={handleCloseModal}
      //   edit={edit}
      //   selectedRow={selectedRow}
      // />
      <ModalComponent
        isOpen={true}
        onClose={handleCloseModal}
        employeeDetails={employeeDetails}
        employeeProfileUiid={employeeProfileUiid}
        immigrationsTableData={immigrationsTableData}
        editData={editData}
      />
    );
  };

  const EmployeeMenus = [
    {
      title: "Overview",
      page: <WorkAuthorizationTab handleEditWorkAuth={handleEditWorkAuth} />,
      type: "main",
      icon: "grid_view",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => handleOpenModal("workAuthorization"),
      //   },
      // ],
    },

    {
      title: "Passport",
      page: <Passport handleEditPassPort={handleEditPassPort} />,
      type: "main",
      icon: "person",
      subTabs: [
        {
          title: "Add",
          icon: "add",
          action: () => handleOpenModal("passport"),
        },
      ],
    },
    {
      title: "I-94",
      page: <I94 handleEdit194={handleEdit194} />,
      type: "main",
      icon: "family_history",
      subTabs: [
        { title: "Add", icon: "add", action: () => handleOpenModal("94") },
        {
          title: "Add I-140",
          icon: "add",
          action: () => handleOpenModal("140"),
        },
      ],
    },
    {
      title: "E-Verifiy",
      page: <EVerifiy handleEditEVerifiy={handleEditEVerifiy} />,
      type: "main",
      icon: "connecting_airports",
      subTabs: [
        {
          title: "Add",
          icon: "add",
          action: () => handleOpenModal("eVerifiy"),
        },
      ],

      // subTabs: !hasEVerifyData
      //   ? [
      //       {
      //         title: "Add",
      //         icon: "add",
      //         action: () => handleOpenModal("eVerifiy"),
      //       },
      //     ]
      //   : [],
    },
    {
      title: "LCA",
      page:
        activeSubTab === "lcaAdd" ? (
          <LcaTab onCreateManual={() => setManualMode(true)} />
        ) : (
          <Lca handleEdit={handleEditLca} />
        ),
      type: "main",
      subTabs:
        activeSubTab === "lcaAdd"
          ? []
          : [
              {
                title: "Add",
                icon: "add",
                action: () => {
                  setActiveSubTab("lcaAdd");
                  handleRemove();
                  setEditData(null);
                },
              },
            ],
    },
    {
      title: "H-1B",
      page:
        activeSubTab === "honeB" ? (
          <HoneBTab
            onCreateManual={() => setManualMode(true)}
            handleBackOrCancel={handleBackOrCancel}
            editData={editData}
            immigrationsTableData={immigrationsTableData}
          />
        ) : (
          <HoneB
            onEdit={handleHoneBEdit}
            immigrationsTableData={immigrationsTableData}
          />
        ),
      type: "main",
      subTabs:
        activeSubTab === "honeB"
          ? []
          : [
              {
                title: "Add",
                icon: "add",
                action: () => {
                  handleAddH1B();
                  setEditData(null);
                },
              },
            ],
    },
    {
      title: "Visa",
      page: <Visa onEdit={handleEditVisa} />,
      type: "main",
      subTabs: [
        {
          title: "Add",
          icon: "add",
          action: () => {
            handleOpenModal("visa");
            handleRemove();
            setEditData(null);
          },
        },
      ],
    },
    {
      title: "L1 Visa",
      page: <div />,
      type: "main",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => {
      //       handleOpenModal("visa");
      //       handleRemove();
      //       setEditData(null);
      //     },
      //   },
      // ],
    },
    {
      title: "E3 Visa",
      page: <div />,
      type: "main",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => {
      //       handleOpenModal("visa");
      //       handleRemove();
      //       setEditData(null);
      //     },
      //   },
      // ],
    },
    {
      title: "TN Visa",
      page: <div />,
      type: "main",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => {
      //       handleOpenModal("visa");
      //       handleRemove();
      //       setEditData(null);
      //     },
      //   },
      // ],
    },
    {
      title: "Green Card",
      page: <div />,
      type: "main",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => {
      //       handleOpenModal("visa");
      //       handleRemove();
      //       setEditData(null);
      //     },
      //   },
      // ],
    },
    {
      title: "Citizen",
      page: <div />,
      type: "main",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => {
      //       handleOpenModal("visa");
      //       handleRemove();
      //       setEditData(null);
      //     },
      //   },
      // ],
    },
    {
      title: "CPT",
      page: <div />,
      type: "main",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => {
      //       handleOpenModal("visa");
      //       handleRemove();
      //       setEditData(null);
      //     },
      //   },
      // ],
    },
    {
      title: "EAD",
      page: <div />,
      type: "main",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => {
      //       handleOpenModal("visa");
      //       handleRemove();
      //       setEditData(null);
      //     },
      //   },
      // ],
    },
    {
      title: "OPT",
      page: <div />,
      type: "main",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => {
      //       handleOpenModal("visa");
      //       handleRemove();
      //       setEditData(null);
      //     },
      //   },
      // ],
    },
    {
      title: "OPT STEM",
      page: <div />,
      type: "main",
      // subTabs: [
      //   {
      //     title: "Add",
      //     icon: "add",
      //     action: () => {
      //       handleOpenModal("visa");
      //       handleRemove();
      //       setEditData(null);
      //     },
      //   },
      // ],
    },
  ];

  const handleMainTabChange = () => {
    setActiveSubTab(null);
  };

  // Tabs for Create Manuval mode
  const manualTabs = [
    {
      title: "LCA Information",
      page: <LCAInformation editData={editData} />,
      type: "main",
    },
    {
      title: "Job Details",
      type: "main",
      page: (
        <JobDetails
          handleBackOrCancel={handleBackOrCancel}
          editData={editData}
        />
      ),
    },
  ];

  useEffect(() => {
    if (employeeProfileUiid && !loadedTabs.includes("placementsTab")) {
      // dispatch(
      //   getAllImmigrationsStart({
      //     uiid: employeeDetails?.immigrations[0]||'',
      //     coll:'Immigration',
      //     ret: "lca",
      //     ref:'LcaDocCert LcaDocPaper'
      //   })
      // );
      const filter = {
        employeeId: { type: "NONE", value: employeeProfileUiid },
        endDate: { type: "GTE", value: new Date() },
      };
      dispatch(
        getCurrentEmployeeImmigration({
          coll: "LCA",
          rsn: "lca",
          filter,
          ref: "Employee Entity Paper Cert",
          incl: ["uiid firstName", "businessName"],
        }),
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch]);
  useEffect(() => {
    if (employeeProfileUiid) {
      dispatch(
        getEmployeeByUiidStart({
          uiid: employeeProfileUiid,
          tab: "immigration",
          ret: "uiid profilePhotoUrl firstName middleName lastName jobTitle status employmentType email mobile immigrations ssn dob bloodType",
        }),
      );
    }
  }, []);

  return (
    <div className="mt-3 flex-1 flex flex-col gap-2">
      <div>
        <PageHeader
          Section={<EmployeeHeader />}
          RightSection={
            <div className="flex gap-3">
              <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                type="link"
                to="/employee"
              />
              {/* <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                // onClick={() =>
                //   navigate("/employee/employee-profile#general--education")
                // }
                onClick={() =>
                  navigate(
                    "/employee/employee-profile?profile-info=general--education",
                  )
                }
              />
              <Button
                color="primary"
                size="sm"
                title={"Next"}
                icon={"east"}
                iconPosition="after"
                // onClick={() =>
                //   navigate("/employee/employee-profile#placements")
                // }
                onClick={() =>
                  navigate(
                    "/employee/employee-profile?placements=placements&profile-info=placements",
                  )
                }
              /> */}
            </div>
          }
        />
      </div>
      <div className="flex-1">
        {/* <NewTab
          tabs={manualMode ? manualTabs : EmployeeMenus}
          color="black"
          variant="outlined"
          //baseUrl="work-authorization"
          parentTitle={"work-authorization"}
          depth={1}
        /> */}
        {manualMode ? (
          <NewTab
            tabs={manualTabs}
            color="black"
            variant="outlined"
            onTabChange={handleMainTabChange}
            defaultTab={0}
            mode="url"
            tabId="work-authorization-manual"
          />
        ) : (
          <NewTab
            tabs={EmployeeMenus}
            color="black"
            variant="outlined"
            onTabChange={handleMainTabChange}
            mode="url"
            tabId="work-authorization-main"
          />
        )}
      </div>
      {renderActiveModal()}
    </div>
  );
};

export default WorkAuthorization;
